export default {
    popup_title: '哈兔免费公开课',
    title_two: '关于中华传统文化的那些事儿',
    title_three: '每月一讲',

    inner_title: '本月预告',

    notice_title: '灯笼',
    notice_conten: '中国灯笼又统称为灯彩，是一种古老的汉族传统工艺品。起源于2000多年前的西汉时期，每年的农历正月十五元宵节前后，人们都挂起象征团圆意义的红灯笼，来营造一种喜庆的氛围。',
    teacher_one: '主讲老师: 吴 娟',
    teacher_two: '上课时间: 2020.5.26',
    teacher_three: '上课地址：https://www.ihatoo.com/index',

    review: '往期回顾'

} 